import React from 'react'
import { UserFilters as UserFiltersType, UserRole } from '../../../types'
import { Search, Users, Filter, Plus } from 'lucide-react'

interface UserFiltersProps {
  filters: UserFiltersType
  onFiltersChange: (filters: UserFiltersType) => void
  onCreateUser: () => void
}

const UserFilters: React.FC<UserFiltersProps> = ({
  filters,
  onFiltersChange,
  onCreateUser
}) => {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onFiltersChange({
      ...filters,
      search: e.target.value
    })
  }

  const handleRoleChange = (role: UserRole | undefined) => {
    onFiltersChange({
      ...filters,
      role
    })
  }

  const handleStatusChange = (isActive: boolean | undefined) => {
    onFiltersChange({
      ...filters,
      isActive
    })
  }

  const handleResetFilters = () => {
    onFiltersChange({
      search: '',
      role: undefined,
      isActive: true
    })
  }

  const roleOptions = [
    { value: undefined, label: '全部角色' },
    { value: 'ADMIN' as UserRole, label: '管理員' },
    { value: 'MANAGER' as UserRole, label: '經理' },
    { value: 'EMPLOYEE' as UserRole, label: '員工' }
  ]

  const statusOptions = [
    { value: undefined, label: '全部狀態' },
    { value: true, label: '啟用' },
    { value: false, label: '停用' }
  ]

  return (
    <div className="card p-6 space-y-4">
      {/* 搜尋欄 */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-secondary-400 w-5 h-5" />
        <input
          type="text"
          placeholder="搜尋姓名或信箱..."
          value={filters.search || ''}
          onChange={handleSearchChange}
          className="input-primary pl-10"
        />
      </div>

      {/* 篩選選項 */}
      <div className="flex flex-wrap gap-4 items-center">
        {/* 角色篩選 */}
        <div className="flex items-center space-x-2">
          <Users className="w-5 h-5 text-secondary-600" />
          <span className="text-sm font-medium text-secondary-700">角色:</span>
          <div className="flex space-x-2">
            {roleOptions.map((option) => (
              <button
                key={option.label}
                onClick={() => handleRoleChange(option.value)}
                className={`px-3 py-1 rounded-lg text-sm font-medium transition-colors ${
                  filters.role === option.value
                    ? 'bg-primary-100 text-primary-700 border border-primary-300'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200 border border-gray-200'
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>

        {/* 狀態篩選 */}
        <div className="flex items-center space-x-2">
          <Filter className="w-5 h-5 text-secondary-600" />
          <span className="text-sm font-medium text-secondary-700">狀態:</span>
          <div className="flex space-x-2">
            {statusOptions.map((option) => (
              <button
                key={option.label}
                onClick={() => handleStatusChange(option.value)}
                className={`px-3 py-1 rounded-lg text-sm font-medium transition-colors ${
                  filters.isActive === option.value
                    ? 'bg-primary-100 text-primary-700 border border-primary-300'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200 border border-gray-200'
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>

        {/* 重設按鈕 */}
        <button
          onClick={handleResetFilters}
          className="btn-ghost text-sm"
        >
          重設篩選
        </button>

        {/* 新增用戶按鈕 */}
        <div className="ml-auto">
          <button
            onClick={onCreateUser}
            className="btn-primary flex items-center space-x-2"
          >
            <Plus className="w-5 h-5" />
            <span>新增成員</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default UserFilters
